import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, useTheme } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography'

// Shared list-page table so every list renders the same way,
// including the empty state: "<n> items", the column headers and "No Data Available".

const CustomTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.action.hover,
    fontWeight: "bold"
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(1),
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
  },
});

const ListTable = ({ classes, columns, rows, emptyMessage }) => {
  const theme = useTheme()

  return (
    <div>
      <Typography variant="caption"><span style={{color: theme.palette.action.active}}>{rows.length} {rows.length === 1 ? 'item' : 'items'}</span></Typography>
      <Paper className={classes.root}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              {columns.map(column => (
                <CustomTableCell key={column.key} align="left">{column.label}</CustomTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <TableRow key={row.id !== undefined ? row.id : index}>
                {columns.map((column, columnIndex) => (
                  columnIndex === 0
                    ? <CustomTableCell key={column.key} component="th" scope="row">{row[column.key]}</CustomTableCell>
                    : <CustomTableCell key={column.key} align="left">{row[column.key]}</CustomTableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {
          rows.length === 0 && <div style={{
            textAlign: "center",
            padding: "15px"
          }}>{emptyMessage}</div>
        }
      </Paper>
    </div>
  );
}

ListTable.propTypes = {
  classes: PropTypes.object.isRequired,
  columns: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.node.isRequired
  })).isRequired,
  rows: PropTypes.array,
  emptyMessage: PropTypes.node
};

ListTable.defaultProps = {
  rows: [],
  emptyMessage: 'No Data Available'
};

export default withStyles(styles)(ListTable);
